import { createAsyncThunkFromFetch } from 'src/store/utils';
import { GetProblemHeadsetsResponse } from './problemHeadsets.types';
import { getProblemHeadsetsAPI } from './problemHeadsets.api';

export const fetchProblemHeadsetsAction = createAsyncThunkFromFetch<
  GetProblemHeadsetsResponse,
  { query?: string }
>('problem_headsets/fetchProblemHeadsets', getProblemHeadsetsAPI);
